<template>
  <div class="text-textColor">
    <transition name="fade">
      <div v-if="showCreateStrategicOutcome" class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full">
        <form @submit.prevent="create" class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full md:h-auto h-screen overflow-auto">
          <transition name="fade">
            <div v-if="loading" class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full">
              <Loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3">
            <p class="text-base">Add Strategic Outcome</p>
            <img class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md" src="@/assets/icons/cross-white.png" @click="close" />
          </div>
          <div class="grid grid-cols-1 p-4 gap-5">
            <!-- Strategic Goal (Dropdown) -->
            <div class="text-sm">
              <label class="block pb-1">Strategic Goal</label>
              <select v-model="info.StrategicGoalId" class="p-2 bg-gray-200 rounded-full w-full">
                <option v-for="goal in strategicGoals" :key="goal.Id" :value="goal.Id">
                  {{ goal.Name }}
                </option>
              </select>
            </div>
            <!-- Key Results -->
            <div class="text-sm">
              <label class="block pb-1">Key Results</label>
              <RichTextEditor @content-changed="handleContentChanged" />
            </div>
          </div>
          <div class="flex justify-end p-5">
            <button class="bg-primary rounded-full px-10 text-sm text-white py-2">
              Create
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import Loader from "@/components/loader/loader.vue";
import RichTextEditor from "@/components/editor/RichTextEditor.vue";
import { mapGetters } from "vuex";
import axios from "axios";


export default {
  name: "CreateStrategicOutcome",
  props: ["showCreateStrategicOutcome", "reload"],
  components: { Loader, RichTextEditor },
  data() {
    return {
      info: {
        StrategicGoalId: null,
        Description: "",
      },
      strategicGoals: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  watch: {
    showCreateStrategicOutcome: {
      handler(newState) {
        if (newState) {
          this.getStrategicGoals();
        }
      },
      immediate: true,
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    handleContentChanged(newContent) {
      this.info.Description = newContent;
    },
    async create() {
      this.loading = true;
      try {
        const options = {
          headers: {
            Authorization: `Bearer ${this.getToken}`,
            "Content-Type": "application/json",
          },
        };
        const response = await axios.post(
          `${this.getOrganization}/performance/strategic/outcome/${this.$ApiVersion}/create`,
          JSON.stringify(this.info),
          options
        );
        this.loading = false;
        if (response.data.StatusCode === 200) {
          this.$emit("close");
          this.$notify.success({
            title: "Success",
            message: response.data.StatusMessage,
          });
          this.info = { StrategicGoalId: null, Description: "" };
          this.reload();
        } else {
          this.$notify.error({
            title: "Failure",
            message: response.data.StatusMessage,
          });
        }
      } catch (error) {
        this.loading = false;
        this.$notify.error({
          title: "Failure",
          message: error?.message,
        });
      }
    },
    async getStrategicGoals() {
      this.loading = true;
      try {
        const url = `${this.getOrganization}/performance/strategic/goal/${this.$ApiVersion}/request`;
        const options = {
          headers: {
            Authorization: `Bearer ${this.getToken}`,
          },
        };
        const response = await axios.get(url, options);
        this.loading = false;
        if (response.data.StatusCode === 200) {
          this.strategicGoals = response.data.Data;
        } else {
          this.get_error = response.data.StatusMessage;
        }
      } catch (error) {
        this.loading = false;
        this.get_error = error.message;
      }
    },
  },
  created() {
    this.getStrategicGoals();
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
